import { ManageSubscriptionPage } from 'teacher-ui-client/components/page/manage/subscription'
import RouteTemplate from 'ember-route-template'

export default RouteTemplate(ManageSubscriptionPage)
